import { render, staticRenderFns } from "./RepointInvestmentAccount.vue?vue&type=template&id=75381b79"
import script from "./RepointInvestmentAccount.vue?vue&type=script&lang=ts"
export * from "./RepointInvestmentAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports